import { Rule } from "@/components/DataCleaning/models/Rule";


export class QueueDataCleaningArgs {

    // Flattened rules
    constructor(public readonly rules: Array<Rule>, 
        public readonly fileId?: string,
        public outputFileName?: string
    ) {
        if (rules == null) throw Error("rules are required");
    }

}